import i18n from '@/i18n'
import huiLocale from 'hui/lib/locale'
import API from 'api/api'
import axios from 'axios'
import { setLanguage as setLanguageInternal } from 'dolphin-plugin-tools'
let assetsUrl = process.env.BASE_URL + process.env.VUE_APP_ASSETS

const setLanguage = async languageId => {
  let _languageId = languageId
  const requestUrl = `${assetsUrl}/i18n/${_languageId}/index.json`
  let i18nJson = null
  try {
    i18nJson = await axios.get(requestUrl)
  } catch (error) {
    console.log(error)
    _languageId = 'en_US'
    i18nJson = await axios.get(`${assetsUrl}/i18n/${_languageId}/index.json`)
  }
  let widgetRequestUrl = await API.common.getLanguageInfo()
  widgetRequestUrl.data.forEach(async item => {
    let widgetI18n = await axios.get(`${item.url}/${_languageId}/index.json`)
    if (widgetI18n) {
      item.list.forEach(key => {
        let temp = {}
        temp[key] = widgetI18n.data[key]
        Object.assign(i18nJson.data, temp)
      })
    }
  })
  await setLanguageInternal(i18nJson.data, _languageId, huiLocale, i18n)
}
const getLanguage = () => {
  let currentLanguage = navigator.language
  if (!currentLanguage) {
    currentLanguage = navigator.browserLanguage
  }
  return currentLanguage.replace(/-/g, '_')
}

export default {
  setLanguage,
  getLanguage
}
